export const SET_DRINK = 'SET_DRINK'
export const SET_DISH_ADDED = 'SET_DISH_ADDED'
export const SET_STARTED = 'SET_STARTED'
export const TOGGLE_APPLIANCE = 'TOGGLE_APPLIANCE'
